/*
 * Ajaxify Cart
 */
window.onload = function(){

	Shopify.AjaxifyCart = (function($){

		var init = function(){
			$(document).ready(function(){
				$('form.product-form[action="/cart/add"]').submit(function(e){
					e.preventDefault();
					var t = $(this),
						 id = t.data('id'),
						 cta = t.find('[type="submit"]'),
						 count = $('.cart-total'),
						 gifts = $('.module-gifts');
					//Add to cart
					$.ajax({
						url: '/cart/add.js',
						dataType: 'json',
						type: 'post',
						data: t.serialize(),
						success: function(itemData){
							$('body').addClass('transition overlay')
							$('#popup-cart-'+id).toggle('slide', {
								direction: 'right',
								easing: $.bez([.45, .05, .19, 1]),
								complete: function(){
									$('body').removeClass('transition')
									$('#popup-cart-'+id).find('.module-popup_content').fadeIn(600, function(){
										//!!! Update cart count
										if(count.length){
											$.getJSON('/cart.js', function(cart){
												count.text(cart.item_count);
												if(gifts.length){
													if(cart.total_price >= gifts.data('reach')){
														gifts.addClass('reached')
													}else{
														gifts.removeClass('reached')
													}
												}
											});
										}
									})
								}
							}, 600);
						},
						error: function(XMLHttpRequest){
							var response = eval('(' + XMLHttpRequest.responseText + ')');
							response = response.description;
							if(response.slice(0,4) === 'All '){
								cta.prop('disabled', true)
								cta.find('span').last().text('SOLD OUT')
							}else{
								cta.prop('disabled', true).addClass('error')
								cta.find('span').last().text('ERROR');
								setTimeout(function(){
									cta.prop('disabled', false).removeClass('error')
									cta.find('span').last().text('ADD TO CART')
								}, 1000);
							}
						}
					});
					return false;
				});
			});
		};
		return{
			init: function(params){
				//Configuration
				params = params || {};
				//Merging with defaults
				$.extend(params);
				//Action
				$(function(){
					init();
				});
			}
		}
	})(jQuery);

	Shopify.AjaxifyCart.init();

}
